export function setBrandTheme() {
  const currentBrand =
    window.top?.aemNamespace && window.top?.aemNamespace.pageEnvironmentVariables.brand?.subBrand;
  if (currentBrand === 'amg') {
    return 'amg';
  } else if (currentBrand === 'maybach') {
    return 'maybach';
  } else {
    return;
  }
}
